/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/ui.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.Ui
 */
export interface Ui {
    /**
     * @generated from protobuf field: optional string type = 1;
     */
    type?: string;
    /**
     * @generated from protobuf field: optional string component = 2;
     */
    component?: string;
    /**
     * @generated from protobuf field: optional bool above_fold = 3;
     */
    above_fold?: boolean;
    /**
     * @generated from protobuf field: optional int64 component_index = 4;
     */
    component_index?: string;
    /**
     * @generated from protobuf field: optional string element = 5;
     */
    element?: string;
    /**
     * @generated from protobuf field: optional int64 element_index = 6;
     */
    element_index?: string;
    /**
     * @generated from protobuf field: optional string fanview_context = 7;
     */
    fanview_context?: string;
    /**
     * @generated from protobuf field: optional string ftp_context = 8;
     */
    ftp_context?: string;
    /**
     * @generated from protobuf field: optional bool locked_content = 9;
     */
    locked_content?: boolean;
    /**
     * @generated from protobuf field: optional string dialog_component = 10;
     */
    dialog_component?: string;
    /**
     * @generated from protobuf field: optional string dialog_element = 11;
     */
    dialog_element?: string;
    /**
     * @generated from protobuf field: optional int64 dialog_component_index = 12;
     */
    dialog_component_index?: string;
    /**
     * @generated from protobuf field: optional int64 dialog_element_index = 13;
     */
    dialog_element_index?: string;
    /**
     * @generated from protobuf field: optional string filter = 14;
     */
    filter?: string;
    /**
     * @generated from protobuf field: optional string user_input = 15;
     */
    user_input?: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Ui$Type extends MessageType<Ui> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.Ui", [
            { no: 1, name: "type", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "carousel", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Type of component - Component name." } },
            { no: 2, name: "component", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "popular_movies_carousel", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Large-grained UI Component such as 'popular_movies_carousel'." } },
            { no: 3, name: "above_fold", kind: "scalar", localName: "above_fold", opt: true, T: 8 /*ScalarType.BOOL*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "true", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "True if the component is above the fold before scrolling" } },
            { no: 4, name: "component_index", kind: "scalar", localName: "component_index", opt: true, T: 3 /*ScalarType.INT64*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Index of the component if it's part of a grid. With index starting from 0." } },
            { no: 5, name: "element", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "element_name", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Fine-grained UI Component such as \u201Cconfirm_button\u201D. This should in general be the same size as the thing the user engages with that triggers a ui_control_activated event." } },
            { no: 6, name: "element_index", kind: "scalar", localName: "element_index", opt: true, T: 3 /*ScalarType.INT64*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Index of the element in the component. With index starting from 0." } },
            { no: 7, name: "fanview_context", kind: "scalar", localName: "fanview_context", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "##", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Fanview Context." } },
            { no: 8, name: "ftp_context", kind: "scalar", localName: "ftp_context", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "##", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Free to play Context." } },
            { no: 9, name: "locked_content", kind: "scalar", localName: "locked_content", opt: true, T: 8 /*ScalarType.BOOL*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "true", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Boolean value representing whether the content is locked or not." } },
            { no: 10, name: "dialog_component", kind: "scalar", localName: "dialog_component", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "##", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???" } },
            { no: 11, name: "dialog_element", kind: "scalar", localName: "dialog_element", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "##", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???" } },
            { no: 12, name: "dialog_component_index", kind: "scalar", localName: "dialog_component_index", opt: true, T: 3 /*ScalarType.INT64*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???" } },
            { no: 13, name: "dialog_element_index", kind: "scalar", localName: "dialog_element_index", opt: true, T: 3 /*ScalarType.INT64*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???" } },
            { no: 14, name: "filter", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "date_selector", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "to determine if the user chose a filter in the ui" } },
            { no: 15, name: "user_input", kind: "scalar", localName: "user_input", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "movies", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Term a user entered in a field, e.g. Dictation field on tvOS for Global Search or Navigation by Voice" } }
        ]);
    }
    create(value?: PartialMessage<Ui>): Ui {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Ui>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Ui): Ui {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string type */ 1:
                    message.type = reader.string();
                    break;
                case /* optional string component */ 2:
                    message.component = reader.string();
                    break;
                case /* optional bool above_fold */ 3:
                    message.above_fold = reader.bool();
                    break;
                case /* optional int64 component_index */ 4:
                    message.component_index = reader.int64().toString();
                    break;
                case /* optional string element */ 5:
                    message.element = reader.string();
                    break;
                case /* optional int64 element_index */ 6:
                    message.element_index = reader.int64().toString();
                    break;
                case /* optional string fanview_context */ 7:
                    message.fanview_context = reader.string();
                    break;
                case /* optional string ftp_context */ 8:
                    message.ftp_context = reader.string();
                    break;
                case /* optional bool locked_content */ 9:
                    message.locked_content = reader.bool();
                    break;
                case /* optional string dialog_component */ 10:
                    message.dialog_component = reader.string();
                    break;
                case /* optional string dialog_element */ 11:
                    message.dialog_element = reader.string();
                    break;
                case /* optional int64 dialog_component_index */ 12:
                    message.dialog_component_index = reader.int64().toString();
                    break;
                case /* optional int64 dialog_element_index */ 13:
                    message.dialog_element_index = reader.int64().toString();
                    break;
                case /* optional string filter */ 14:
                    message.filter = reader.string();
                    break;
                case /* optional string user_input */ 15:
                    message.user_input = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Ui, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string type = 1; */
        if (message.type !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.type);
        /* optional string component = 2; */
        if (message.component !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.component);
        /* optional bool above_fold = 3; */
        if (message.above_fold !== undefined)
            writer.tag(3, WireType.Varint).bool(message.above_fold);
        /* optional int64 component_index = 4; */
        if (message.component_index !== undefined)
            writer.tag(4, WireType.Varint).int64(message.component_index);
        /* optional string element = 5; */
        if (message.element !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.element);
        /* optional int64 element_index = 6; */
        if (message.element_index !== undefined)
            writer.tag(6, WireType.Varint).int64(message.element_index);
        /* optional string fanview_context = 7; */
        if (message.fanview_context !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.fanview_context);
        /* optional string ftp_context = 8; */
        if (message.ftp_context !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.ftp_context);
        /* optional bool locked_content = 9; */
        if (message.locked_content !== undefined)
            writer.tag(9, WireType.Varint).bool(message.locked_content);
        /* optional string dialog_component = 10; */
        if (message.dialog_component !== undefined)
            writer.tag(10, WireType.LengthDelimited).string(message.dialog_component);
        /* optional string dialog_element = 11; */
        if (message.dialog_element !== undefined)
            writer.tag(11, WireType.LengthDelimited).string(message.dialog_element);
        /* optional int64 dialog_component_index = 12; */
        if (message.dialog_component_index !== undefined)
            writer.tag(12, WireType.Varint).int64(message.dialog_component_index);
        /* optional int64 dialog_element_index = 13; */
        if (message.dialog_element_index !== undefined)
            writer.tag(13, WireType.Varint).int64(message.dialog_element_index);
        /* optional string filter = 14; */
        if (message.filter !== undefined)
            writer.tag(14, WireType.LengthDelimited).string(message.filter);
        /* optional string user_input = 15; */
        if (message.user_input !== undefined)
            writer.tag(15, WireType.LengthDelimited).string(message.user_input);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.Ui
 */
export const Ui = new Ui$Type();
